import { combineReducers } from 'redux';
import {
  SET_CONTAINER_FULL_WIDTH_OPTION,
  SET_CONTAINER_FIXED_OPTION
} from '../actions/action-names';

const fullWidth = (state = false, action) => {
  switch (action.type) {
    case SET_CONTAINER_FULL_WIDTH_OPTION:
      return action.isFullWidth;
    default:
      return state;
  }
};

const fixed = (state = false, action) => {
  switch (action.type) {
    case SET_CONTAINER_FIXED_OPTION:
      return action.isFixed;
    default:
      return state;
  }
};

export default combineReducers({
  fullWidth,
  fixed
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/container-options-reducers.js